/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, breakpoints } from '@coursera/cds-core';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

const originalStyles = {
  section: css`
    background-color: var(--cds-color-neutral-primary-invert);
    min-height: 44px;
    display: flex;
    align-items: center;
    ${breakpoints.down('xs')} {
      min-height: 64px;
    }

    /* We are iterating quickly on a follow-up after negative results, hacking solution to changing color. */
    .cds-breadcrumbs-listItem > a,
    .cds-breadcrumbs-listItem button > svg {
      color: var(--cds-color-neutral-primary-weak) !important;
    }

    .cds-breadcrumbs-list {
      align-items: center;
    }
  `,
  pageGridContainerOverrides: css`
    > div {
      margin-top: 0;
      margin-bottom: 0;
    }
  `,
  breadcrumbs: css`
    white-space: nowrap;
  `,
};

const redesignStyles = {
  section: css`
    background-color: transparent;
    display: flex;
    align-items: center;
    padding-top: var(--cds-spacing-50);

    /* We are iterating quickly on a follow-up after negative results, hacking solution to changing color. */
    .cds-breadcrumbs-listItem > a,
    .cds-breadcrumbs-listItem button > svg {
      color: var(--cds-color-neutral-primary-weak) !important;
    }

    .cds-breadcrumbs-list {
      align-items: center;
    }

    nav {
      margin-left: 0;

      ol,
      ul {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
  `,
  pageGridContainerOverrides: css`
    > div {
      margin-top: 0;
      margin-bottom: 0;
    }
  `,
  breadcrumbs: css`
    white-space: nowrap;
  `,
};

type Props = {
  breadcrumbs?: React.ReactNode;
  ctas?: Array<React.ReactNode>;
};

const BreadcrumbsModule = ({ breadcrumbs, ctas }: Props) => {
  const { enableXDPRedesignPhase1 } = useXDPRedesignPhase1Data();
  const styles = enableXDPRedesignPhase1 ? redesignStyles : originalStyles;

  if (!breadcrumbs && !ctas) {
    return null;
  }

  return (
    <section css={styles.section}>
      <PageGridContainer css={styles.pageGridContainerOverrides}>
        <Grid
          item
          container
          xs={12}
          style={{ paddingBottom: 0, paddingTop: 0 }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={8} css={styles.breadcrumbs}>
            {breadcrumbs}
          </Grid>
          <Grid item container xs={4} justifyContent="flex-end">
            {ctas}
          </Grid>
        </Grid>
      </PageGridContainer>
    </section>
  );
};

export default BreadcrumbsModule;
